export const strokeStyle = (extraStroke = false) => ({
  webkitTextStroke: extraStroke ? "1px black" : "",
  textShadow: `
3px 3px 0 #000,
-1px -1px 0 #000,  
1px -1px 0 #000,
-1px 1px 0 #000,
1px 1px 0 #000`,
});
